import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";
import { keys } from "./keys";

async function reopenSubTopic(id: string) {
  const { error } = await apiClient
    .from('sub_topics')
    .update({
      state: 'pending',
      archived_at: null,
      archived_by: null,
    })
    .eq('id', id)

  if (error) {
    throw error
  }
}

export function useReopenSubTopic() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (subTopicId: string) => reopenSubTopic(subTopicId),
    onSuccess: () => {
      enqueueSnackbar('Sujet réouvert.', 'success');

      queryClient.invalidateQueries({ queryKey: keys.lists() });
    }
  })
}
